import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { TextButton } from '../../../components/common';
import { MainSource } from '../../../constants/Source';
import { ClickOrigin, useTrackTrashActions } from '../../../utils/hooks/bi/useTrackTrashActions';
import { RouteBuilder } from '../../../utils/RouteHelpers';
import { Truncated } from './components';
import { GenericNotification } from './GenericNotification';

export const undoRemoveNotification = ({ items }) => {
  const UndoRemoveNotification = ({ onUndoRemove, notification }) => {
    const { trackRestore } = useTrackTrashActions();

    const handleUndoClick = useCallback(
      (...args) => {
        trackRestore(items, { clickOrigin: ClickOrigin.Notifications });
        onUndoRemove(items, notification)(...args);
      },
      [trackRestore, items, onUndoRemove, notification],
    );

    return (
      <GenericNotification
        dataHook="notification.moved-to-trash"
        notification={notification}
        buttonProps={{ label: <FormattedMessage id="notification.undo" />, onClick: handleUndoClick }}
        text={
          <FormattedMessage
            id="files-manager.move-to-trash-notification"
            values={{
              itemsCount: items.length,
              itemName: <Truncated>{items[0].name}</Truncated>,
              trashLink: (
                <TextButton
                  as={Link}
                  size="small"
                  to={RouteBuilder.Source(MainSource.Trash)}
                  underline="always"
                  skin="dark"
                  dataHook="notification-link"
                >
                  <FormattedMessage id="categories.trash" />
                </TextButton>
              ),
            }}
          />
        }
      />
    );
  };

  return UndoRemoveNotification;
};
